import { connect } from "react-redux";

import Modal from "@components/Modal";
import RegisterForm from "@containers/Account/RegisterForm";
import { addModal } from "@store/app/actions";

const RegisterModal = ({ modalId, addModal, loginModalId }) => (
  <Modal id={modalId} header="Creeaza cont nou">
    <RegisterForm hasGrid={true} redirect={false} />

    <div className="text-center">
      <button
        type="button"
        onClick={() => addModal(loginModalId)}
        className="text-sm text-red-brand hover:text-bleu-hover underline"
      >
        Intra in cont
      </button>
    </div>
  </Modal>
);

export default connect(null, {
  addModal,
})(RegisterModal);
